const defaultItemValues = {
  title: '',
  tags: [],
  number1: 0,
  number2: 0,
  number3: 0,
  string1: '',
  string2: '',
  string3: '',
  text1: '',
  text2: '',
  text3: '',
  date1: '',
  date2: '',
  date3: '',
  checkbox1: false,
  checkbox2: false,
  checkbox3: false,
}

export default defaultItemValues;